import { View } from "binder"
import { ProductLineManipulationViewModel, ProductLine } from "./productLineManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class ProductLineManipulationView extends View<ProductLineManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-6DA4CBAA-06B9-4200-816B-6E8D7B0F54A2"
    }
    loadHtml(): string {
        let element = require('./productLineManipulation.html').default;
        let style = require('./productLineManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productLines(v: ProductLine) { this._productLines = v; } public get productLines(): ProductLine { return this._productLines; } private _productLines: ProductLine;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
